// Footer.js
import React from "react";
import "./footer.css";
import Icons from "../../config/images";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-main-div">
          {/* Left */}
          <div className="footer-left-part">
            <img
              src={Icons.logo}
              alt="Office Logo"
              className="logo-image-style"
              onClick={() => {
                navigate("/");
                window.scrollTo({ top: 0 });
              }}
            />
          </div>

          {/* Right */}
          <div className="footer-right-part">
            <div className="footer-right-part-childs">
              <ul>
                <li className="first-li">Quick Links</li>
                <li
                  onClick={() => {
                    navigate("/about");
                    window.scrollTo({ top: 0 });
                  }}
                >
                  About us
                </li>
                <li
                  onClick={() => {
                    navigate("/contact-us");
                    window.scrollTo({ top: 0 });
                  }}
                >
                  Contact us
                </li>
                <li
                  onClick={() => {
                    navigate("/services");
                    window.scrollTo({ top: 0 });
                  }}
                >
                  Services
                </li>
                {/* <li onClick={() => navigate("/career")}>Careers</li> */}
              </ul>
            </div>

            <div className="footer-right-part-childs">
              <ul>
                <li className="first-li">Services</li>
                <li>UI/UX Design</li>
                <li>Mobile Application</li>
                <li>Web Development</li>
              </ul>
            </div>

            <div className="footer-right-part-childs">
              <ul>
                <li className="first-li">Legal</li>
                <li
                  onClick={() => {
                    navigate("/privacy-policy");
                    window.scrollTo({ top: 0 });
                  }}
                >
                  Privacy Policy
                </li>
                <li
                  onClick={() => {
                    navigate("/terms-and-conditions");
                    window.scrollTo({ top: 0 });
                  }}
                >
                  Terms & Conditions
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Social */}
        <div className="footer-social-media-section">
          <img
            src={Icons.instagramIcon}
            alt="Instagram"
            onClick={() =>
              window.open("https://www.instagram.com/bacodesolutions", "_blank")
            }
          />
          <img
            src={Icons.linkedInIcon}
            alt="LinkedIn"
            onClick={() =>
              window.open(
                "https://www.linkedin.com/in/ba-code-solutions-45709730b/",
                "_blank",
              )
            }
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
